<template>
  <div class="income">
    <div class="flex gap-8 items-start mb-6">
      <div class="flex-1 bg-white rounded-md px-6 py-5 flex items-start justify-between">
        <div class="">
          <p class="text-neutral-500">Total Pendapatan</p>
          <p class="text-lg font-bold mb-6">Rp 37.000.000</p>
          <p class="text-xs text-neutral-500">Tarkhir Update, Sep 20</p>
        </div>
        <span class="w-10 h-10 bg-primary-100 rounded-full flex justify-center items-center">
          <Transaction color="neutral-700" />
        </span>
      </div>
      <div class="flex-1 bg-white rounded-md px-6 py-5 flex items-start justify-between">
        <div class="">
          <p class="text-neutral-500">Total Pendapatan</p>
          <p class="text-lg font-bold mb-6">Rp 37.000.000</p>
          <p class="text-xs text-neutral-500">Tarkhir Update, Sep 20</p>
        </div>
        <span class="w-10 h-10 bg-primary-100 rounded-full flex justify-center items-center">
          <Transaction color="neutral-700" />
        </span>
      </div>
      <div class="flex-1 bg-white rounded-md px-6 py-5 flex items-start justify-between">
        <div class="">
          <p class="text-neutral-500">Total Pendapatan</p>
          <p class="text-lg font-bold mb-6">Rp 37.000.000</p>
          <p class="text-xs text-neutral-500">Tarkhir Update, Sep 20</p>
        </div>
        <span class="w-10 h-10 bg-primary-100 rounded-full flex justify-center items-center">
          <Transaction color="neutral-700" />
        </span>
      </div>
    </div>
    <div class="flex items-center gap-5 mb-6">
      <div class="w-1/2 flex items-center gap-5">
        <div class="w-1/2">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Bulan</label>
          <CustomSelect :options="monthList" v-model="selectedMonth" :default="selectedMonth" />
        </div>
        <div class="w-1/2">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tahun</label>
          <CustomSelect :options="yearList" v-model="selectedYear" :default="selectedYear" />
        </div>
      </div>
      <div class="w-1/2 flex items-end gap-5">
        <div class="w-1/2">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Cari no order, nama pembeli" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
        <div class="w-1/2 flex justify-end ">
          <Button buttonText="Export Data" size="big" :icon="() => import('@/components/Icons/Export')" />
        </div>
      </div>
    </div>
    <div class="bg-white">
      <div class="flex items-center tab shadow-border-b mdmax:overflow-x-auto">
        <div
          class="relative px-6 py-3 cursor-pointer text-center font-medium"
          v-for="(tab, index) in tabList"
          :key="'tab-' + index"
          :class="[tab.active ? 'active text-neutral-700' : 'text-neutral-500']"
          @click="selectTab(tab)"
        >
          {{ tab.title }}
        </div>
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <div v-if="column.field === 'transaction'">
          <p class="text-sm">{{ entry.transaction.orderId }}</p>
          <p class="text-xs text-neutral-500">{{ entry.transaction.awb }}</p>
        </div>
        <div v-else-if="column.field === 'status'">
          <p class="rounded-md inline-block text-xs py-1 px-2 bg-system-warning text-white">{{ entry.status }}</p>
        </div>
        <span v-else>{{ entry[column.field] || '-' }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    Transaction: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Transaction'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination'),
    Button: () => import(/* webpackChunkName: "button" */ '@/components/Forms/Button')
  },
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      selectedMonth: null,
      theMonths: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      tabList: [
        {
          title: 'Semua',
          active: true
        },
        {
          title: 'Dana Masuk',
          active: false
        },
        {
          title: 'Dana Keluar',
          active: false
        }
      ],
      selectedTab: '',
      columns: [
        { label: 'Tanggal', field: 'date' },
        { label: 'Status', field: 'status' },
        { label: 'Tipe', field: 'type' },
        { label: 'Transaksi', field: 'transaction' },
        { label: 'Pendapatan', field: 'income' },
        { label: 'Saldo', field: 'balance' }
      ],
      data: [
        {
          date: '16 Oct 2021',
          status: 'Process',
          type: 'Pengiriman',
          transaction: {
            orderId: 'LN-5631',
            awb: 'AWB: 878931904123789'
          },
          income: '+Rp 30.000',
          balance: 'Rp 35.890.000'
        }
      ],
      searchTerm: '',
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true
    }
  },
  mounted() {
    const d = new Date()
    this.selectedMonth = this.theMonths[d.getMonth()]
    this.selectTab(this.tabList[0])
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    yearList() {
      return this.generateArrayOfYears()
    },
    monthList() {
      return this.theMonths
    },
    filteredData() {
      return this.data
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  methods: {
    selectTab(tab) {
      this.tabList.forEach(item => (item.active = false))
      const tabIndex = this.tabList.findIndex(item => item.title === tab.title)
      this.tabList[tabIndex].active = true
      this.selectedTab = tab
    },
    onPageChange(page) {
      this.currentPage = page
    },
    generateArrayOfYears() {
      var max = new Date().getFullYear()
      var min = max - 9
      var years = []
      for (var i = max; i >= min; i--) {
        years.push(i)
      }
      return years
    }
  }
}
</script>
<style lang="scss" scoped>
.tab {
  .active {
    &::after {
      content: '';
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
</style>
